const pipelineConfig = {
  BASE_URL: "https://warehouse-api.dev.syncrosale.com",
  KC_HOST: "https://auth.dev.syncrosale.com/",
  KC_REALM: "warehouse",
  KC_CLIENT_ID: "warehouse",
  ENV: "dev",
};

/* 
  Dev config for local development:
  BASE_URL: "https://warehouse-api.dev.syncrosale.com",
  KC_HOST: "https://auth.dev.syncrosale.com",
*/

/*
  BASE_URL: "http://localhost:8083",
  KC_HOST: "http://localhost:8080",
*/
const devConfig = {
  BASE_URL: "https://warehouse-api.dev.syncrosale.com",
  KC_HOST: "https://auth.dev.syncrosale.com",
  KC_REALM: "warehouse",
  KC_CLIENT_ID: "warehouse",
  ENV: "dev",
};

export const config = {
  BASE_URL: pipelineConfig.BASE_URL.startsWith("%%")
    ? devConfig.BASE_URL
    : pipelineConfig.BASE_URL,
  KC_HOST: pipelineConfig.KC_HOST.startsWith("%%")
    ? devConfig.KC_HOST
    : pipelineConfig.KC_HOST,
  KC_REALM: pipelineConfig.KC_REALM.startsWith("%%")
    ? devConfig.KC_REALM
    : pipelineConfig.KC_REALM,
  KC_CLIENT_ID: pipelineConfig.KC_CLIENT_ID.startsWith("%%")
    ? devConfig.KC_CLIENT_ID
    : pipelineConfig.KC_CLIENT_ID,
  ENV: pipelineConfig.ENV.startsWith("%%") ? devConfig.ENV : pipelineConfig.ENV,
};

export const isDevelopment =
  config.ENV.toLowerCase() === devConfig.ENV.toLowerCase();
